import { TextField, TextFieldProps } from "@material-ui/core";
import React from "react";

export default (props: TextFieldProps) => {
  const { value, ...other } = props;

  return <TextField {...other} value={value ?? ""} />;
};
